import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Fires a GA4 `page_view` event whenever the SPA route changes.
 * The gtag.js snippet in /public/index.html configures GA with
 * `send_page_view: false`, so this component is the single source of
 * truth for pageviews.
 */
export default function Analytics() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    const page_path = pathname + (search || "");
    window.gtag("event", "page_view", {
      page_path,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [pathname, search]);

  return null;
}
